module.exports = __webpack_public_path__ + "assets/8e5436529799e43d9c4562e5523df732.png";